import { defineComponent as _defineComponent } from 'vue'
import { isReadonly, ref, withDefaults } from "vue";

export interface Props {
  isOpen?: boolean;
  isDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppExpandableSection',
  props: {
    isOpen: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isOpen: boolean, isDisabled: boolean }



const isSectionOpen = ref<boolean>(props.isOpen);

return { __sfc: true,props, isSectionOpen }
}

})